<template>
  <div class="wrapper">
    <vue-confirm-dialog></vue-confirm-dialog>
    <div class="upload">
      <header class="header">
        <h1>
          <a href="/">
            <svg>
              <use xlink:href="/svg/sprite.svg#logo-side" />
            </svg>
          </a>
        </h1>
      </header>
      <h2 class="page_title">アカウント登録</h2>
      <div class="form">
        <dl class="form_list">
          <dt>会社名/団体名</dt>
          <dd>
            <input
              type="text"
              v-model="company"
              placeholder="株式会社壱番屋"
              :class="{'error':errors.company}"
              class="text-type03"
            />
            <span class="error__text" v-show="errors.company">{{errors.company}}</span>
          </dd>
          <dt>担当者</dt>
          <dd>
            <input type="text" v-model="name" :class="{'error':errors.name}" class="text-type03" />
            <span class="error__text" v-show="errors.name">{{errors.name}}</span>
          </dd>
          <dt>メールアドレス</dt>
          <dd>
            <input
              type="text"
              v-model="email"
              placeholder="〇〇〇〇〇@ichibanya.jp"
              :class="{'error':errors.email}"
              class="text-type03"
            />
            <span class="error__text" v-show="errors.email">{{errors.email}}</span>
          </dd>
        </dl>
        <div class="btnbox">
          <button type="button" v-on:click="setSubmit()" class="btn01 cl_pp">登録する</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Mixin } from "../mixin";
export default {
  name: "upload",
  mixins: [Mixin],
  data() {
    return {
      company: "",
      name: "",
      email: "",
      errors: {}, // エラー
      connect_flg: false, // 通信フラグ
    };
  },
  methods: {
    // 登録処理
    setSubmit() {
      this.errors = {}; // 初期化
      if (!this.company) this.errors.company = "未入力です";
      if (!this.name) this.errors.name = "未入力です";
      if (!this.email) this.errors.email = "未入力です";

      // エラーがなければサブミット
      if (Object.keys(this.errors).length == 0 && !this.connect_flg) {
        var loader = this.loadingShow();
        // 通信開始
        this.connect_flg = true;
        let params = new URLSearchParams();
        params.append("c", "sign_up");
        params.append("company", this.company);
        params.append("name", this.name);
        params.append("email", this.email);

        this.axios
          .post(this.RequestURI, params, {
            headers: {
              "Cache-Control": "no-cache",
            },
          })
          .then((response) => {
            if (response.data.status == "success") {
              // 成功
              loader.hide();
              this.$confirm({
                message: "登録が完了しました",
                button: {
                  yes: "OK",
                },
                /**
                 * Callback Function
                 * @param {Boolean} confirm
                 */
                callback: (confirm) => {
                  if (confirm) {
                    this.$router.push("/");
                  }
                },
              });
            } else if (response.data.status == "inputError") {
              loader.hide();
              // 入力エラー
              // エラーセット
              this.errors = response.data.errors;
              // エラー位置にスクロール
              this.errorScrollBack();
            } else {
              loader.hide();
              // ログインに戻す
              this.removeLogin();
            }
          })
          .catch(() => {
            loader.hide();
            this.removeLogin();
          });
      } else {
        // エラー位置にスクロール
        this.errorScrollBack();
      }
      // 通信終了
      this.connect_flg = false;
    },

    errorScrollBack() {
      //スクロールを最上位へ
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
    },
  },
};
</script>